<p-table
  [value]="phrases"
  [loading]="loading"
  (onRowReorder)="onRowReorder($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem"></th>
      <th>{{ "translate.claim-tool-doc-phrase-merge-and-reorder.select-for-merge-column" | translate }}</th>
      <th>{{ "translate.claim-tool-doc-phrase-merge-and-reorder.phrase-id-column" | translate }}</th>
      <th>{{ "translate.claim-tool-doc-phrase-merge-and-reorder.phrase-text-column" | translate }}</th>
    </tr>
  </ng-template>
  

  <ng-template pTemplate="body" let-phrase let-rowIndex="rowIndex">
    <tr [pReorderableRow]="rowIndex"
    [ngClass]="{ 'highlight-row': phrase.phrase_id == curPhraseId }">
      <td>
        <i class="pi pi-bars" [class.drag-disabled]="mergeExecuted || splitExecuted" pReorderableRowHandle style="cursor: move"></i>
      </td>
      <td>
        <input *ngIf="phrase.phrase_id != curPhraseId" type="checkbox"
        [disabled]="splitExecuted" 
        (change)="onCheckboxChange($event.target.checked, phrase)" />
      </td>
      <td>{{ phrase.phrase_id }}</td>
      <td>{{ phrase.phrase_text }}</td>
    </tr>
  </ng-template>

</p-table>